import { request } from '../index'

export function filter(params={}){
    return request({url: "nfce/", params})
}

export function getBatches() {
    return request({ url: `export-nfce-batch/` })
}

export function exportBatch(data) {
    return request({ url: `export-nfce-batch/`, method: "POST", data })
}

export function syncBatch(protocolNumber) {
    return request({ url: `export-nfce-batch/${protocolNumber}/sync/` })
}

export function downloadBatch(protocolNumber) {
    return request({ url: `export-nfce-batch/${protocolNumber}/download-batch/` })
}


// WEBPACK FOOTER //
// ./src/api/nfce/index.js